export const FuelCodes = {
  FullTank: 'F', // Not applicable to electric vehicles
  Blank: '', // Not full tank
} as const;

export type FuelCodes = (typeof FuelCodes)[keyof typeof FuelCodes];
